/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_DetailsInputs */

const id_staff_resellers_details = /** @type {(inputs: Staff_Resellers_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat detail`)
};

const en_staff_resellers_details = /** @type {(inputs: Staff_Resellers_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View details`)
};

/**
* | output |
* | --- |
* | "View details" |
*
* @param {Staff_Resellers_DetailsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_details = /** @type {((inputs?: Staff_Resellers_DetailsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_DetailsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_details(inputs)
	return id_staff_resellers_details(inputs)
});